import React, { useContext, useEffect, useRef, useState } from "react";
import "../styles/styles.css";
import { Link, useNavigate } from "react-router-dom";
import { registrationUrl, SEND_OTP, VERIFY_OTP } from "../Service/service";
import { postData } from "../Service/ApiMethod";
// import Otp from "../pages/login/Otp";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css"
import OtpInput from "react-otp-input";
import Geocode from "react-geocode";
// import { candata } from "../App";
import Loader from "../pages/login/Loader";
import { allTimeZone } from "../pages/login/Countrycode";
import { lang } from "../lang";

// import SuccessPopupMsg from "./Success-popup-msg";
// import axios from "axios";

const Registration = () => {
  const navigate = useNavigate();

  const navigateToSuccess = () => {

    currentLocation()

    setTimeout(() => {
      navigate('/map')
    }, 1000)
  };
  const [ln,setLn] = useState('en')
  const [password, setPassword] = useState();
  const [confirmpassword, setConfirmPassword] = useState();
  // const [username, setUserName] = useState();
  const [firstname, setFirstName] = useState();
  const [lastname, setLastName] = useState();
  const [email, setEmail] = useState();
  const [phone, setPhone] = useState();
  const [countryCode, setCountryCode] = useState('')
  const [error, setError] = useState('');
  const [otpphon, setOtpphon] = useState("")
  // const [otp1, setOtp1] = useState("");
  // const [otp2, setOtp2] = useState("");
  // const [otp3, setOtp3] = useState("");
  // const [otp4, setOtp4] = useState("");
  // const [otp5, setOtp5] = useState("");
  // const [otp6, setOtp6] = useState("");
  const [otp, setOtp] = useState(false);
  const [showPassword, setShowPassword] = useState(false)
  const [showPasswords, setShowPasswords] = useState(false)
  // const [seconds, setSeconds] = useState(30);
  // const [timerOn, setTimerOn] = useState(false);
  const [resendSeconds, setResendSeconds] = useState(0);
  const [sendOtp, setSendOtp] = useState(false);
  const [loaderStart, setLoaderstart] = useState(false) 
  const [checkNumber,setChecknumber] = useState("")
  // const { newData, setNewData } = useContext(candata)


  // by VTT

  const verifyOtp = async () => {
    setLoaderstart(true)
    console.log("verify otp fn");
    // const fullOtp = otp1 + otp2 + otp3 + otp4 + otp5 + otp6;
    const fullOtp = OTP;
    const obj = {
      phone: otpphon,
      otp: fullOtp,
      user_types: "recruiter",
    };
    console.log('object fullotp', obj)

    await postData(obj, VERIFY_OTP)
      .then((res) => res.json())
      .then((data) => {
        console.log('verify otp response', data);
        setLoaderstart(false)
        // alert(data?.error_message)
        try {
          console.log("From Api", data)
          const token = data?.data?.access;
          console.log('token', token)
          localStorage.setItem(
            "catzapp_token",
            token,
            "login_Phone",
            data?.data?.user?.phone
          );
          if (token !== undefined) {
            navigateToSuccess();
            alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth[data?.message]:"");
            // setNewData(!newData)
          } else {
            alert(data?.error_message?.otp != undefined ? lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth[data?.error_message?.otp]:"" : lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth[data?.error_message]:"")
          }
        } catch (err) {
          console.log("error hgappended", err);
          setLoaderstart(false)
          // setError(err.message, " already exists");

        }
        // try {
        //   if (data.errors) {
        //     alert(data?.errors?.otp[0])
        //     console.log(data?.errors?.otp[0]);
        //   }else{
        //     alert(data?.message)
        //     navigateToSuccess();
        //   }
        // } catch (err) {
        //   console.log(err);
        //   alert(data.errors.otp[0]);
        //   // <SuccessPopupMsg message={data.errors.otp[0]}/>
        // }
      });
  };

  // Geocode.setApiKey("AIzaSyAn7_5pFRSJ_i1lbbiitBzZinnYY7VTGxk");



  const countryCodes = useRef(null)
  const [countryCod, setCountrycod] = useState('fi')
  useEffect(() => {
    if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
    locations()
  })

  const locations = async () => {
    if (navigator?.geolocation) {
      await navigator?.geolocation?.getCurrentPosition(function (position) {
        console.log("Latitude is :", position?.coords?.latitude);
        console.log("Longitude is :", position?.coords?.longitude);

       
        localStorage.setItem('lat', position?.coords?.latitude);
        localStorage.setItem('lng', position?.coords?.longitude);
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        const reverseGeocodingUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyAn7_5pFRSJ_i1lbbiitBzZinnYY7VTGxk`;

        // call Reverse Geocoding API - https://www.geoapify.com/reverse-geocoding-api/
        fetch(reverseGeocodingUrl)
          .then((response) => response.json())
          .then((data) => {
            if (data.status === 'OK') {
              var address = data.results[0].address_components;
              const countryComponent = data.results[0].address_components.find(
                component => component.types.includes('country')
              );

              if (countryComponent) {
                const countryShortCode = countryComponent.short_name;
                console.log(countryShortCode, "ssssss"); // Display the country short code
                allTimeZone.map((item) => {
                  if (item.Code == countryShortCode) {
                    console.log(item.Code.toLowerCase(), "onnnnnnnn000000",countryCodes.current);
                    countryCodes.current = item.Code.toLowerCase()
                    setCountrycod(item.Code.toLowerCase())
                  }
                })
              }

              // Do something with the address
              console.log(address, "0000000000000000000000000000000000000000000000");
            } else {
              // Handle the error case
              // console.log('Error: ' + data.status);
            }
          })
          .catch((error) => {
            // console.log('Error: ' + error.message);
          });

      }, function (error) {
        console.log(error);
      });

    } else {
      console.log('error in locating')
    }

  }

















  const currentLocation = async () => {

    if (navigator?.geolocation) {
      await navigator?.geolocation?.getCurrentPosition(function (position) {
        console.log("Latitude is :", position?.coords?.latitude);
        console.log("Longitude is :", position?.coords?.longitude);

        // setLatitude(position?.coords?.latitude);
        // setLongitude(position?.coords?.longitude);
        localStorage.setItem('lat', position?.coords?.latitude);
        localStorage.setItem('lng', position?.coords?.longitude);
      }, function (error) {
        console.log(error);
      });

    } else {
      console.log('error in locating')
    }

  };
  const validpassword = (pass) => {
    return pass.match(
      // /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
    );
  }
  

  var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  // var namePattern = /^[a-zA-Z-]+$/;
  const validPhoneNumber = (phoneNumber) => {
    return /^[1-9][0-9]*$/.test(phoneNumber);
};


  const signUp = async () => {
    setLoaderstart(true)
    if(checkNumber.charAt(0) === '0'){
      // setChecknumber("+"+countryCode+ phone.slice(1))
      // setPhone(countryCode+ phone.slice(1))
      setOtpphon("+"+countryCode+ checkNumber.slice(1))
    }else{
      setOtpphon("+"+countryCode+ checkNumber)
    }
    let fcm_recruiters = await localStorage.getItem("FCM")
    // if (username.trim() === '') {
    //     setError('Please enter your name');
    //     return;
    // }

    // if (phone.trim() === '') {
    //     setError('Please enter your Number yrr');
    //     return;
    // } else if (password.trim() === '' || password.trim().length < 8) {
    //     setError('Minimum 8 character lenght required');
    //     return;
    // }




    let objItem = {
      username: checkNumber.charAt(0) === '0' ? "+"+countryCode+ checkNumber.slice(1) :"+"+countryCode+ checkNumber,
      country_code: countryCode,
      first_name: firstname,
      last_name: lastname,
      phone: checkNumber.charAt(0) === '0' ? "+"+countryCode+ checkNumber.slice(1) :"+"+countryCode+ checkNumber,
      email: email,
      password: password,
      user_types: "recruiter",
      firebase_token: "null",
      fcm_recruiter:fcm_recruiters
    };

    console.log(phone,"Static", objItem);


    if (!firstname ) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.FinalFinal['Please Enter First Name']:"")
      setLoaderstart(false)
    } if (!lastname) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.FinalFinal['Please Enter Last Name']:"")
      setLoaderstart(false)
    }
    // else if (!namePattern.test(firstname)) {
    //   alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth['Space are not allowed']:"")
    //   setLoaderstart(false)
    // }
    // else if (!namePattern.test(lastname)) {
    //   alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth['Space are not allowed']:"")
    //   setLoaderstart(false)
    // }
    else if ( phone == undefined) {
      console.log(phone,"ddddddd")
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.LoginPassword['Please Enter Your Mobile Number']:"")
      setLoaderstart(false)
    } 
     else if (!phone) {
      console.log(phone,"ddddddd")
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.LoginPassword['Please Enter Your Mobile Number']:"")
      setLoaderstart(false)
    }
    //  else if (!validPhoneNumber(checkNumber)) {
    //   console.log(phone,"ddddddd")
    //   alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["Enter Valid Mobile Number"]:"")
    //   setLoaderstart(false)
    // }
     else if (!email) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.FinalFinal['Please Enter Email']:"")
      setLoaderstart(false)
    }else if (!emailPattern.test(email)) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.new['Please Enter valid Email']:'')
      setLoaderstart(false)
    }else if (!password) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.NewSubUser['Enter Password']:'')
      setLoaderstart(false)
    } else if(!validpassword(password)){
      alert("A password should be alphanumeric.First letter of the password should be capital.Password must contain a special character (@, $, !, &, etc).Password length must be greater than 8 characters.");
      setLoaderstart(false)
    }else if (!confirmpassword) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.NewSubUser['Confirm Password']:'')
      setLoaderstart(false)
    } else if (password !== confirmpassword) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.ChangePassword["Password dosen't Match"]:'')
      setLoaderstart(false)
    } else {
      console.log(phone,"ccccsssssss")
      if(firstname != "" || lastname != ""){
        await postData(objItem, registrationUrl)
        .then((response) => response.json())
        .then((data) => {
          console.log(data,"tttttttttttttttttttttt")
          setLoaderstart(false)
         
          // localStorage.setItem("language","en")
          if (data?.errors) {
            // alert(data?.errors?.phone)
            alert(data.errors?.password[0])
            setOtp(false);
          } else if (data?.error_message) {
            alert(data?.error_message)
            setOtp(false);
          } else {
            alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth[data?.message]:"")
            setOtp(true);
          }

        })
        .catch((err) =>{
          console.log("err", err.message)
          setLoaderstart(false)
        }
        )
      setResendSeconds(30);
      const intervalId = setInterval(() => {
        setResendSeconds(prevSeconds => prevSeconds - 1);
      }, 1000);

      // Stop the timer after 30 seconds
      setTimeout(() => {
        clearInterval(intervalId);
        setResendSeconds(0);
      }, 30000);
      }else{
        alert("Please check something is missing")
        setLoaderstart(false)
      }
     
    }
  };



  const handleResendOTP = () => {
    setOTP("");
    let objItem = {
      user_types: "recruiter",
      phone: otpphon,
    };
    console.log("static", objItem);
    postData(objItem, SEND_OTP)
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.status_code == 200) {
          setSendOtp(true);
          alert(data.message);
        }
      })
      .catch((err) => {
        console.log("Error in categories from Post Form", err);
        console.log(" code Error", err);
      });

    setResendSeconds(30);
    const intervalId = setInterval(() => {
      setResendSeconds(prevSeconds => prevSeconds - 1);
    }, 1000);

    // Stop the timer after 30 seconds
    setTimeout(() => {
      clearInterval(intervalId);
      setResendSeconds(0);
    }, 30000);
  };




  const [OTP, setOTP] = useState("");
  function handleChange(OTP) {
    setOTP(OTP);

  }


  // useEffect(() => {
  //   let interval = null;
  //   if (timerOn) {
  //     interval = setInterval(() => {
  //       setSeconds((seconds) => seconds - 1);
  //     }, 1000);
  //     if (seconds === 0) {
  //       clearInterval(interval);
  //       setTimerOn(false);
  //     }
  //   } else {
  //     clearInterval(interval);
  //   }
  //   return () => clearInterval(interval);
  // }, [timerOn, seconds]);

  // const handleResendOTP = () => {
  //   let objItem = {
  //     user_types: "recruiter",
  //     phone: `+${phone}`,
  //   };
  //   console.log("static", objItem);
  //   postData(objItem, SEND_OTP)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       console.log(data);
  //       if (data.status_code == 200) {
  //         setSendOtp(true);
  //         alert(data.message);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("Error in categories from Post Form", err);
  //       console.log(" code Error", err);
  //     });
  // };



  // Start the timer
  //   setResendSeconds(30);
  //   const intervalId = setInterval(() => {
  //     setResendSeconds(prevSeconds => prevSeconds - 1);
  //   }, 1000);

  //   // Stop the timer after 30 seconds
  //   setTimeout(() => {
  //     clearInterval(intervalId);
  //     setResendSeconds(0);
  //   }, 30000);
  // };



  return (
    <>
    {
    loaderStart == true ? (<Loader/>):null
   }
      {console.log(error)}
      <div className="login-section">
        <div
          className="image-layer image-layer-2"
          style={{}}
        ></div>
        <div className="outer-box">
          {/* <!-- Login Form --> */}
          <div className="login-form default-form">
            <div className="form-inner">
              <h3>{lang && Object.keys(lang).length > 0 ? lang[ln]?.MyProfile["Create an Account"]:""}</h3>

              {/* <!--Login Form--> */}
              {otp ? (
                <>
                  <div className="mobile_four_digit_verification_code  justify-content-between my-3">
                    <p> {lang && Object.keys(lang).length > 0 ? lang[ln]?.interOtp["we have sent an OTP to"]:""} {otpphon}</p>
                    <OtpInput inputStyle={{ width: '87%', fontSize: '15px' }}
                      onChange={handleChange}
                      className="mobile_four_digit_verification_code flex-center justify-content-between my-3 "
                      // name="ssn-3"
                      value={OTP}
                      isInputNum="number"
                      id="OTP"
                      numInputs={6}
                   
                      separator={<span></span>}

                    />

                    <button
                      className="theme-btn"
                      onClick={() => {
                        verifyOtp();
                        console.log("Clickedd");
                      }}
                    >
                      {lang && Object.keys(lang).length > 0 ? lang[ln]?.ResetPassword["Submit OTP"]:""}
                    </button>
                  </div>

                  <div className="text-center text mt-2 " style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  {lang && Object.keys(lang).length > 0 ? lang[ln]?.interOtp["Did Not Receive Code Yet?"]:""}  {!resendSeconds && <button className="resend" onClick={handleResendOTP}>{lang && Object.keys(lang).length > 0 ? lang[ln]?.interOtp["Resend OTP"]:""}</button>}{resendSeconds > 0 && <div className=" resend mx-2">00:{resendSeconds} sec</div>}

                  </div>

                  {/* <div>
      {!resendSeconds && <button  className="theme-btn" onClick={handleResendOTP}>Resend OTP</button>}
      {resendSeconds > 0 && <div  className="theme-btn">Resend OTP in {resendSeconds} seconds</div>}
    </div> */}

                </>
              ) : (
                <>
                  <div className="form-group">
                  </div>

                  <div className="form-group">
                    <label for='firstname-field'>{lang && Object.keys(lang).length > 0 ? lang[ln]?.MyProfile["First Name"]:""}</label>
                    <input className="input-text w-100 p1-2 passwordLoginInput"
                      style={{ backgroundColor: 'white', color: 'black', border: '0.5px solid gray' }}
                      onChange={(e) => {
                        setFirstName(e.target.value);
                      }}
                      placeholder={lang && Object.keys(lang).length > 0 ? lang[ln]?.MyProfile["First Name"]:""}
                      id='firstname-field'
                      defaultValue=''
                      type="text"
                      name="firstName"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label for='lastname-field'>{lang && Object.keys(lang).length > 0 ? lang[ln]?.MyProfile["Last Name"]:""}</label>
                    <input className="input-text w-100 p1-2 passwordLoginInput"
                      style={{ backgroundColor: 'white', color: 'black', border: '0.5px solid gray' }}
                      onChange={(e) => {
                        setLastName(e.target.value);
                      }}
                      placeholder={lang && Object.keys(lang).length > 0 ? lang[ln]?.MyProfile["Last Name"]:""}
                      id='lastname-field'
                      defaultValue=''
                      type="text"
                      name="lastName"
                      required
                    />
                  </div>


                  <div className="form-group">
                    <label for='phone'>{lang && Object.keys(lang).length > 0 ? lang[ln]?.SignUp["Enter Your Phone Number"]:""}</label>
                    {/* <input
                      onChange={(e) => {
                        setPhone(e.target.value);
                      }}
                      value={phone}
                      id="number-field"
                      type="text"
                      name="phone"
                      defaultValue='+91'
                      placeholder="Phone Number"
                    /> */}
                    <PhoneInput inputStyle={{ width: '100%', fontSize: '19px', border: '0.5px solid gray' }}
                      placeholder="Enter Mobile Number"
                      type='text'
                      country={countryCod}
                      enableSearch={true}
                      // defaultValue='+91'
                      onChange={(phone, selectedCountry) => {
                        const phoneNumberWithoutCode = phone.replace(selectedCountry.dialCode, '');
                        console.log(phoneNumberWithoutCode,"ow")
                        setChecknumber(phoneNumberWithoutCode)
                        setPhone(phone)
                        setCountryCode(selectedCountry.dialCode)
                      }}
                      name=''
                      id='phone'
                    />
                  </div>
                  <div className="form-group">
                    <label for='email-field'>{lang && Object.keys(lang).length > 0 ? lang[ln]?.MyProfile["Email"]:""}</label>
                    <input className="input-text w-100 p1-2 passwordLoginInput"
                      style={{ backgroundColor: 'white', color: 'black', border: '0.5px solid gray' }}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      value={email}
                      id="email-field"
                      type='email'
                      name="email"
                      placeholder={lang && Object.keys(lang).length > 0 ? lang[ln]?.MyProfile["Email"]:""}

                    />
                  </div>
                  <div className="form-group" style={{ position: 'relative' }} >
                    <label for='password-field'>{lang && Object.keys(lang).length > 0 ? lang[ln]?.NewSubUser["Enter Password"]:""}</label>
                    <input className="input-text w-100 p1-2 passwordLoginInput"
                      style={{ backgroundColor: 'white', color: 'black', border: '0.5px solid gray' }}
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                      value={password}
                      id="password-field"
                      type={showPassword ? 'text' : "password"}
                      name="password"
                      placeholder={lang && Object.keys(lang).length > 0 ? lang[ln]?.NewSubUser["Enter Password"]:""}

                    />
                    <span onClick={() => setShowPassword(!showPassword)} style={{ cursor: 'pointer', position: 'absolute', right: '5%', top: '60%' }} >
                      {showPassword ? <i className="fa fa-eye" aria-hidden="true" /> : <i class="fa fa-eye-slash" aria-hidden="true" />}
                    </span>
                  </div>


                  <div className="form-group" style={{ position: 'relative' }} >
                    <label for='password-field'>{lang && Object.keys(lang).length > 0 ? lang[ln]?.NewSubUser["Confirm Password"]:""}</label>
                    <input className="input-text w-100 p1-2 passwordLoginInput"
                      style={{ backgroundColor: 'white', color: 'black', border: '0.5px solid gray' }}
                      onChange={(e) => {
                        setConfirmPassword(e.target.value);
                      }}
                      value={confirmpassword}
                      id="password-field"
                      type={showPasswords ? 'text' : "password"}
                      name="password"
                      placeholder={lang && Object.keys(lang).length > 0 ? lang[ln]?.NewSubUser["Confirm Password"]:""}

                    />
                    <span onClick={() => setShowPasswords(!showPasswords)} style={{ cursor: 'pointer', position: 'absolute', right: '5%', top: '60%' }} >
                      {showPasswords ? <i className="fa fa-eye" aria-hidden="true" /> : <i class="fa fa-eye-slash" aria-hidden="true" />}
                    </span>
                  </div>




                  <div className="form-group">
                    <button
                      className="theme-btn btn-style-one py-2"
                      type=""
                      onClick={signUp}
                      name="Register"
                     >
                      {lang && Object.keys(lang).length > 0 ? lang[ln]?.LoginPassword["SignUp"]:""}
                    </button>
                  </div>

                  <div className="bottom-box pt-0">
                    <Link to="/" className="link text-underline">
                      <span> {lang && Object.keys(lang).length > 0 ? lang[ln]?.Home["Login Now"]:""}</span>
                    </Link>
 

                  </div>

                </>
              )}

            </div>
          </div>
          {/* <!--End Login Form --> */}
        </div>
      </div>
    </>
  );
};

export default Registration;
